// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"945285b7","257":"ba41c795","279":"97effb1c","299":"9693dc25","331":"d1ee5e5d","338":"1951efd2","453":"e8fca69a","635":"62629a85","693":"3f3969ba"}[chunkId] + ".chunk.js";
};